import { render, staticRenderFns } from "./FileFeesPaidsFormAdd.vue?vue&type=template&id=2943a038&scoped=true&"
import script from "./FileFeesPaidsFormAdd.vue?vue&type=script&lang=js&"
export * from "./FileFeesPaidsFormAdd.vue?vue&type=script&lang=js&"
import style0 from "./FileFeesPaidsFormAdd.vue?vue&type=style&index=0&id=2943a038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2943a038",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VFileInput})
